<template>
   <img :src="imgUrl"/>
</template>
<script>
export default {
  name: 'ImagePreview',
  components: {},
  props: {
    src: {
      type: String,
      required: true
    }
  },
  watch: {
    src (value) {
      if (value) {
        this.getUrl(value)
      }
    }
  },
  data () {
    return {
      imgUrl: ''
    }
  },
  created () {
    if (this.src) {
      this.getUrl(this.src)
    }
  },
  methods: {
    getUrl (src) {
      const params = {
        fileUrl: src
      }
      this.api.commonService.getTokenUrl(params).then(data => {
        if (data.errorMessage) {
          this.$message.error(data.errorMessage)
        } else {
          this.imgUrl = data.body
        }
      })
    }
  }
}
</script>
<style lang='less' scoped>
</style>



// WEBPACK FOOTER //
// src/area-base/components/preview/Image.vue